import React, { useState, useEffect } from 'react';
import { Select } from 'antd';
import { ASSET_TYPE } from '@/components/scene/react-three-components/sceneAsset';
import styles from '../../../event-timeline.module.css';

type NPCSelectFromExistingProps = {
  selectableAssets: any[];
  params: any;
  setParams: (params: any) => void;
};

export default function NPCSelectFromExisting({
  selectableAssets,
  params,
  setParams,
}: NPCSelectFromExistingProps) {
  const [objectId, setObjectId] = useState(params.assetId || '');

  const filteredNPCAssets = selectableAssets.filter(
    (asset) =>
      asset.props.asset.type === ASSET_TYPE.GLTF.OTHER &&
      asset.props.asset.isDisabledOnSceneLoad === true
  );

  function onChangeObjectId(value: string) {
    setObjectId(value);
    setParams({
      ...params,
      inventoryItemId: '',
      previewImage: '',
      assetId: value,
    });
  }

  useEffect(() => {
    setObjectId(params?.assetId || '');
  }, [params?.assetId]);

  return (
    <>
      <div className={styles.selectNPCType}>
        <h1 className={styles.h1Label}>Select NPC in the Scene</h1>
        {filteredNPCAssets?.length > 0 ? (
          <Select
            value={objectId}
            onChange={onChangeObjectId}
            placeholder='Select NPC'
            style={{ width: '100%' }}
          >
            {filteredNPCAssets?.map((asset) => (
              <Select.Option
                key={
                  asset.props.asset.id || asset.props.asset.ref.current?.uuid
                }
                value={
                  asset.props.asset.id || asset.props.asset.ref.current?.uuid
                }
              >
                {asset.props.asset.name}
              </Select.Option>
            ))}
          </Select>
        ) : (
          'No NPCs added to the scene yet.'
        )}
      </div>
    </>
  );
}
